/**
 * Normalize hotel names for display while preserving known all-caps tokens.
 */
export function normalizeHotelName(raw: string): string {
	const words = raw
		.trim()
		.split(/\s+/)
		.filter(Boolean);

	return words
		.map((word) => {
			if (/^[^a-z]*[A-Z][A-Z0-9&/.-]*$/.test(word)) {
				return word;
			}
			return word
				.split("-")
				.map((part) => {
					if (!part) return part;
					if (/^[A-Z0-9&/.-]+$/.test(part) && /[A-Z]/.test(part)) {
						return part;
					}
					return part[0].toUpperCase() + part.slice(1).toLowerCase();
				})
				.join("-");
		})
		.join(" ");
}
